<template>
  <div id="password" class="card mt-4">
    <div class="card-header">
      <h5>비밀번호 변경</h5>
    </div>
    <div class="card-body pt-0">
      <div class="mb-3">
        <material-input
          id="currentPassword"
          type="password"
          variant="static"
          label="현재 비밀번호"
          v-model="passwordData.current"
        />
      </div>
      <div class="mb-3">
        <material-input
          id="newPassword"
          type="password"
          variant="static"
          label="새 비밀번호"
          v-model="passwordData.new"
        />
      </div>
      <div class="mb-3">
        <material-input
          id="confirmPassword"
          type="password"
          variant="static"
          label="비밀번호 확인"
          v-model="passwordData.confirm"
        />
      </div>
      <h5 class="mt-5">비밀번호 요구사항</h5>
      <p class="text-muted mb-2">
        안전한 비밀번호를 위해 다음 지침을 따라주세요:
      </p>
      <ul class="text-muted ps-4 mb-0 float-start">
        <li>
          <span class="text-sm">최소 1개의 특수문자 포함</span>
        </li>
        <li>
          <span class="text-sm">최소 8자 이상</span>
        </li>
        <li>
          <span class="text-sm">최소 1개의 숫자 포함 (2개 권장)</span>
        </li>
        <li>
          <span class="text-sm">정기적으로 변경하세요</span>
        </li>
      </ul>
      <material-button
        class="float-end mt-6 mb-0"
        color="dark"
        variant="gradient"
        size="sm"
        @click="updatePassword"
      >
        비밀번호 업데이트
      </material-button>
    </div>
  </div>
</template>

<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  name: "PasswordChangeCard",
  components: {
    MaterialInput,
    MaterialButton,
  },
emits: ['update-password'],
  data() {
    return {
      passwordData: {
        current: "",
        new: "",
        confirm: "",
      },
    };
  },
  methods: {
    updatePassword() {
      if (!this.passwordData.current || !this.passwordData.new || !this.passwordData.confirm) {
        this.$notify({ type: 'warn', text: '모든 필드를 입력해주세요.' });
        return;
      }

      if (this.passwordData.new !== this.passwordData.confirm) {
        this.$notify({ type: 'error', text: '새 비밀번호가 일치하지 않습니다.' });
        return;
      }

      if (this.passwordData.new.length < 8) {
        this.$notify({ type: 'error', text: '비밀번호는 최소 8자 이상이어야 합니다.' });
        return;
      }

      this.$emit("update-password", this.passwordData);
    },
  },
};
</script>
